import React from "react";

// Previous / next paging for any list (page numbers come from the API's page info)
export default function Pager({ page, pages, total, onPage, noun = "items" }) {
  if (!total) return null;
  return (
    <div className="pager">
      <span>
        {total} {noun} · page {page} of {pages}
      </span>
      <div>
        <button className="outline-btn" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          ← Previous
        </button>
        <button className="outline-btn" disabled={page >= pages} onClick={() => onPage(page + 1)}>
          Next →
        </button>
      </div>
    </div>
  );
}
